/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(function() {
        const wishlistBtn = document.querySelector('#shopify-block-wishlist_king_wishlist_button_block_YGCTaK');
        const customWishlist = document.querySelector('.custom-wishlist-btn');
        if (wishlistBtn && customWishlist) {
            customWishlist.appendChild(wishlistBtn);
        }
    }, 500);

    const mobileGallery = document.querySelector(".mobile-media-gallery");
    if (mobileGallery) {
        mobileGallery.addEventListener('click', function() {
            const galleryRow = document.querySelector(".media-gallery-with-text_mo-row");
            if (galleryRow) {
                if (galleryRow.style.display === "none" || galleryRow.style.display === "") {
                    galleryRow.style.display = "block";
                } else {
                    galleryRow.style.display = "none";
                }
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-add-to-cart], .product__submit__add-custom-bundle')
        .forEach(btn => {
            btn.addEventListener('click', () => {
                const checkbox = document.querySelector('#add_applicator');
                if (!checkbox?.checked) return;

                const quantity = Number(document.querySelector('.qty-applicator.custom-bundles [data-quantity-select]')?.innerText) || 1;

                console.log("Applicator Quantity: ", quantity, "Applicator id:", checkbox.dataset.productId);
                addApplicator(checkbox.dataset.productId, quantity);
            });
        });

    async function addApplicator(id, quantity) {
        const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: id,
                quantity: quantity
            })
        });

        if (!addRes.ok) return;

        window.cart?.getCart();
    }




    // Cart bar js

    const productSection = document.querySelector('.shopify-section--product');
    const cartBar = document.querySelector('.shopify-section--product .cart-bar');

    if (productSection && cartBar) {
        const observer = new IntersectionObserver(
            ([entry]) => {
                cartBar.classList.toggle('is-sticky', !entry.isIntersecting);
            }, {
                root: null,
                threshold: 0
            }
        );

        observer.observe(productSection);
    }
})

// document.addEventListener("DOMContentLoaded", function () {

//     const switcher = document.querySelector(".currency-switcher-header-link");
//     const active = switcher.querySelector(".currency-select.active");

//     // Only store selection for current domain
//     const DOMAIN_KEY = "selectedCountry_pixyls";
//     const CURRENT_DOMAIN = window.location.hostname;

//     // =========================
//     // DROPDOWN TOGGLE & CLICK
//     // =========================
//     document.addEventListener("click", function (e) {
//         const switcherEl = e.target.closest(".currency-switcher-header-link");
//         const activeEl = e.target.closest(".currency-select.active");
//         const link = e.target.closest(".currency-dropdown a");

//         // Toggle dropdown
//         if (activeEl && switcherEl) {
//             e.stopPropagation();
//             const dropdown = switcherEl.querySelector(".currency-dropdown");
//             document.querySelectorAll(".currency-dropdown").forEach(d => {
//                 if (d !== dropdown) d.style.display = "none";
//             });
//             dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
//         }

//         // Country clicked
//         if (link) {
//             e.preventDefault();
//             const dropdown = link.closest(".currency-dropdown");
//             const switcherEl = link.closest(".currency-switcher-header-link");
//             const activeEl = switcherEl.querySelector(".currency-select.active");

//             const img = link.querySelector("img").src;
//             const text = link.querySelector("span").innerText;
//             const url = link.href;

//             // Update UI immediately
//             activeEl.querySelector("img").src = img;
//             activeEl.querySelector(".text").innerText = text;
//             dropdown.style.display = "none";

//             // Save only if same domain
//             const linkDomain = new URL(url).hostname;
//             if (linkDomain === CURRENT_DOMAIN) {
//                 localStorage.setItem(DOMAIN_KEY, JSON.stringify({ img, text, url }));
//             }

//             // Redirect
//             window.location.href = url;
//         }

//         // Close dropdown when clicking outside
//         if (!e.target.closest(".currency-switcher-header-link")) {
//             document.querySelectorAll(".currency-dropdown").forEach(d => {
//                 d.style.display = "none";
//             });
//         }
//     });

//     // =========================
//     // SET ACTIVE COUNTRY ON PAGE LOAD
//     // =========================
//     const savedCountry = JSON.parse(localStorage.getItem(DOMAIN_KEY));
//     const currentPath = window.location.pathname.replace(/\/$/, "");

//     let matched = false;

//     if (savedCountry && CURRENT_DOMAIN === "pixyls.ca") {
//         // Use saved selection **only if on the same domain**
//         active.querySelector("img").src = savedCountry.img;
//         active.querySelector(".text").innerText = savedCountry.text;
//         matched = true;
//     }

//     if (!matched) {
//         // Otherwise, detect by URL
//         document.querySelectorAll(".currency-dropdown a").forEach(link => {
//             const url = new URL(link.href);
//             const linkHost = url.hostname;
//             const linkPath = url.pathname.replace(/\/$/, "");

//             // Only check pixyls.ca links
//             if (linkHost === CURRENT_DOMAIN && (linkPath === currentPath || (currentPath === "" && linkPath === ""))) {
//                 const img = link.querySelector("img").src;
//                 const text = link.querySelector("span").innerText;
//                 active.querySelector("img").src = img;
//                 active.querySelector(".text").innerText = text;
//                 matched = true;
//             }
//         });

//         // Fallback to Canada if no match
//         if (!matched) {
//             const defaultLink = document.querySelector(".currency-dropdown a[href='https://pixyls.ca/']");
//             active.querySelector("img").src = defaultLink.querySelector("img").src;
//             active.querySelector(".text").innerText = defaultLink.querySelector("span").innerText;
//             localStorage.removeItem(DOMAIN_KEY); // reset stored selection
//         }
//     }

// });


// document.addEventListener("input", function (e) {

//   if (!e.target.matches(".select-popout__search-input")) return;

//   const input = e.target;
//   const filter = input.value.toLowerCase();
//   const dropdown = input.closest(".currency-dropdown");
//   const items = dropdown.querySelectorAll(".currency-dropdown__wrap li:not(.select-popout__search)");

//   items.forEach(li => {
//     const text = li.textContent.toLowerCase();

//     if (text.includes(filter)) {
//       li.style.display = "";
//     } else {
//       li.style.display = "none";
//     }
//   });

// });


// function getSelectedSub() {
//   const currentPath = window.location.pathname;
//   const topTabs = document.querySelectorAll(
//     '.mega-menu_top-tabs .top-tabs__column[data-toggle-target]'
//   );

//   let matchedTopTab = null;
//   let matchedTarget = null;

//   topTabs.forEach(tab => {
//     const target = tab.dataset.toggleTarget;
//     if (!target) return;

//     const handle = target.replace('.', '').replace('-tab-content', '');
//     if (!currentPath.includes(handle)) return;

//     matchedTopTab = tab;
//     matchedTarget = target;
//   });

//   if (!matchedTopTab || !matchedTarget) return;

//   // reset states
//   document.querySelectorAll('.mega-menu-bottom-row.active')
//     .forEach(el => el.classList.remove('active'));

//   topTabs.forEach(tab => tab.classList.remove('active'));

//   // activate matched
//   matchedTopTab.classList.add('active');

//   const bottomRow = document.querySelector(`.mega-menu-bottom-row${matchedTarget}`);
//   if (bottomRow) bottomRow.classList.add('active');

//   const tabContent = document.querySelector(matchedTarget);
//   if (!tabContent) return;

//   const bottomTabsWrap = tabContent.querySelector('.mega-menu__bottom-tabs');
//   if (bottomTabsWrap) bottomTabsWrap.classList.add('loaded-handle');

//   const firstBottomTab = tabContent.querySelector(
//     '.mega-menu__bottom-tabs .mega-menu__bottom-tab'
//   );
//   const firstContentCol = tabContent.querySelector(
//     '.mega-menu__content-row .mega-menu__content-column'
//   );

//   if (firstBottomTab) firstBottomTab.classList.add('active');
//   if (firstContentCol) firstContentCol.classList.add('active');
// }

// function showMenuOnHov() {
//     const header = document.querySelector('header');
//     const originalMegaMenu = document.querySelector('.mega-menu-section');
//     if (!header || !originalMegaMenu) return;

//     const megaMenu = originalMegaMenu.cloneNode(true);
//     originalMegaMenu.remove();
//     header.appendChild(megaMenu);

//     const menuHovItems = document.querySelectorAll('#NavStandard .menu__items.menu__items--primary .menu__item');
//     menuHovItems.forEach(item => {
//         item.addEventListener('mouseenter', () => {
//             megaMenu.classList.add('is-active');
//             header.classList.add('megamenu-opened');
//         });

//         item.addEventListener('mouseleave', () => {
//             megaMenu.classList.remove('is-active');
//             header.classList.remove('megamenu-opened');
//         });
//     });

//     megaMenu.addEventListener('mouseenter', () => {
//         megaMenu.classList.add('is-active');
//         header.classList.add('megamenu-opened');
//     });

//     megaMenu.addEventListener('mouseleave', e => {
//         megaMenu.classList.remove('is-active');
//         header.classList.remove('megamenu-opened');
//     })
// }

// function selectMenu() {
//     const topTabs = document.querySelectorAll('.top-tabs__column');
//     const bottomTabsContainers = document.querySelectorAll('.mega-menu__bottom-tabs');

//     topTabs.forEach(tab => {
//         tab.addEventListener('click', (e) => {
//             e.preventDefault();

//             const target = tab.dataset.toggleTarget;

//             topTabs.forEach(t => t.classList.remove('active'));
//             tab.classList.add('active');

//             const allRows = document.querySelectorAll('.mega-menu-bottom-row');
//             allRows.forEach(row => row.classList.remove('active'));

//             const activeRow = document.querySelector(target);
//             if (activeRow) {
//                 activeRow.classList.add('active');

//                 const tabs = activeRow.querySelectorAll('.mega-menu__bottom-tab');
//                 const columns = activeRow.querySelectorAll('.mega-menu__content-column');

//                 tabs.forEach(t => t.classList.remove('active'));
//                 columns.forEach(c => c.classList.remove('active'));

//                 if (tabs[0]) tabs[0].classList.add('active');
//                 if (columns[0]) columns[0].classList.add('active');
//             }
//         });
//     });

//     bottomTabsContainers.forEach(container => {
//         container.addEventListener('click', (e) => {
//             const tab = e.target.closest('.mega-menu__bottom-tab');
//             if (!tab) return;

//             e.preventDefault();

//             const target = tab.dataset.toggleTarget;
//             const row = tab.closest('.mega-menu-bottom-row');

//             const tabs = row.querySelectorAll('.mega-menu__bottom-tab');
//             tabs.forEach(t => t.classList.remove('active'));
//             tab.classList.add('active');

//             const columns = row.querySelectorAll('.mega-menu__content-column');
//             columns.forEach(c => c.classList.remove('active'));

//             const activeColumn = row.querySelector(target);
//             if (activeColumn) activeColumn.classList.add('active');
//         });
//     });
// }

// document.addEventListener("DOMContentLoaded", () => {
//     getSelectedSub();
//     showMenuOnHov();
//     selectMenu();

//     const menuItems = document.querySelectorAll('.menu__item[data-link-handle]');

//     menuItems.forEach(item => {
//         item.addEventListener('mouseenter', () => {
//             const handle = item.dataset.linkHandle;

//             const handlePage = document.querySelector(".loaded-handle") || document;

//             const relatedTab = handlePage.querySelector(`.mega-menu__bottom-tab[data-link-handle="${handle}"]`);
//             if (relatedTab) {
//                 relatedTab.click();
//             }
//         });
//     });


//     const mobileMenuButton = document.querySelector('#open-mobile-nav__custom');
//     const mobileCloseButton = document.querySelector('.mobile-menu__close .close-btn');
//     const megaMenu = document.querySelector('.mega-menu-section');

//     if (mobileMenuButton) {
//         mobileMenuButton.addEventListener('click', () => {
//             megaMenu?.classList.add('is-active');
//         });
//     }

//     if (mobileCloseButton) {
//         mobileCloseButton.addEventListener('click', () => {
//             megaMenu?.classList.remove('is-active');
//         });
//     }
// })



// Upsells and close buttons

function removeAddedUpsells() {
  const cartItems = document.querySelectorAll('.cart-drawer__items .cart__item');
  const cartVariantIds = new Set();

  cartItems.forEach(function (item) {
    const variantId = item.getAttribute('data-item-id');
    if (variantId) cartVariantIds.add(variantId);
  });

  const upsellItems = document.querySelectorAll('.custom-best-selling .product-upsell__holder');
  upsellItems.forEach(function (upsell) {
    const upsellVariantId = upsell.getAttribute('data-item-id');
    if (upsellVariantId && cartVariantIds.has(upsellVariantId)) {
      upsell.classList.add('hidden');
    } else {
      upsell.classList.remove('hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return;

  const observer = new MutationObserver(function () {
    if (!cartDrawer.classList.contains('is-open')) return;

    // ---- 1. Pair products close button ----
    const closeButton = document.getElementById('bottom_upsell_close');
    const pairDiv = document.querySelector('[data-pair-products-holder]');

    if (closeButton && pairDiv && closeButton.dataset.listenerAttached !== 'true') {
      closeButton.dataset.listenerAttached = 'true';
      closeButton.addEventListener('click', function () {
        pairDiv.classList.add('hidden');
        closeButton.classList.add('hidden');
      });
    }

    // ---- 2. Best selling close button ----
    const bestSellingClose = document.querySelector('.close_icon');
    const bestSellingDiv = document.querySelector('.best-selling-product');

    if (bestSellingClose && bestSellingDiv && bestSellingClose.dataset.listenerAttached !== 'true') {
      bestSellingClose.dataset.listenerAttached = 'true';
      bestSellingClose.addEventListener('click', function () {
        bestSellingDiv.classList.add('hidden');
      });
    }

    removeAddedUpsells();
  });

  observer.observe(cartDrawer, { attributes: true });
});

document.addEventListener('theme:cart:update', removeAddedUpsells);


////////////////TOLSTOY


function initVideoMuteButtons(scope = document) {

  scope.querySelectorAll('.video-mute').forEach(button => {

    // avoid duplicate listeners
    if (button.dataset.muteInit) return;
    button.dataset.muteInit = true;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const video = this
        .closest('.tolstoy-media')
        ?.querySelector('video');

      if (!video) return;


      if (video.muted) {

        // unmute
        video.muted = false;
        video.volume = 1;

        this.classList.remove('is-muted');

      } else {

        // mute
        video.muted = true;

        this.classList.add('is-muted');
      }

    });

  });

}


// Collapsible Single touch targer for level 1 menu items

document.addEventListener('click', (event) => {
  if (window.innerWidth >= theme.sizes.large) return;

  const link = event.target.closest(
    '.mobile-menu__item--level-1 > .mobile-navlink--level-1, ' +
    '.mobile-menu__item--level-2 > .mobile-navlink--level-2'
  );

  if (!link) return;

  const trigger = link.nextElementSibling;

  if (!trigger?.matches('[data-collapsible-trigger]')) return;

  event.preventDefault();
  trigger.click();
});

// Collapsible Single touch targer for level 1 menu items